import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { IconTitleDescComponent } from 'src/app/shared/components/icon-title-desc/icon-title-desc.component';
import { officeInfos } from '../../constants-monisfer-infos';

@Component({
  selector: 'app-office',
  imports: [IconTitleDescComponent, NgOptimizedImage, MatProgressSpinnerModule],
  templateUrl: './office.component.html',
  styleUrl: './office.component.scss',
})
export class OfficeComponent {
  readonly officeInfos = officeInfos;
}
